import loadable from '@loadable/component';

export const AsyncMapProperties = loadable(
    () =>
        import(
            /* webpackChunkName: "map-properties" */
            /* webpackPrefetch: true */
            './MapProperties'
        ),
    {ssr: false}
);
